import { FC, Fragment, ReactNode, useMemo } from 'react';

export interface SearchTextHighlighterProps {
    content: string;
    globalSearchRegExp: RegExp | null; // must have the 'g' flag for matchAll
}

export const SearchTextHighlighter: FC<SearchTextHighlighterProps> = ({
    content,
    globalSearchRegExp,
}) => {
    const node = useMemo((): ReactNode => {
        if (!globalSearchRegExp) {
            return content;
        }

        const children: ReactNode[] = [];
        let lastIndex = 0;
        for (const match of content.matchAll(globalSearchRegExp)) {
            children.push(content.substring(lastIndex, match.index));
            children.push(<span className="bg-yellow-400">{match[0]}</span>);
            lastIndex = match.index! + match[0].length;
        }
        children.push(content.substring(lastIndex));
        return children;
    }, [content, globalSearchRegExp]);

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <Fragment>{node}</Fragment>;
};
SearchTextHighlighter.displayName = 'SearchTextHighlighter';
